import { Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModalController, PopoverController } from '@ionic/angular';
import { AuftragService } from 'src/app/api/auftrag.service';
import { Logger } from 'src/app/api/helper/app-error-logger';
import { MyApp } from 'src/app/api/helper/app';
import { Artikel } from 'src/app/api/model/swagger-model';
import { RemoteService } from 'src/app/api/remote.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { UiHelper } from 'src/app/api/helper/ui-helper';
import { WareneingangScan } from 'src/app/api/model/model';
import { StammdatenService } from 'src/app/api/stammdaten.service';
import { AuftragArtikelAuswahlPage } from 'src/app/auftragsliste/artikel-auswahl/artikel-auswahl.component';
import { debounceTime } from 'rxjs/operators';

import moment from 'moment';

const log = new Logger("WareneinganScanPage");

@Component({
    selector: 'app-wareneingang-scan',
    templateUrl: './wareneingang-scan.page.html',
    styleUrls: ['./wareneingang-scan.page.scss'],
    standalone: false
})
export class WareneinganScanPage implements OnInit, AfterViewInit, OnDestroy {

    static instance: WareneinganScanPage = null;

    @Input() entity: WareneingangScan;
    @Input() isAendern: boolean;

    form: UntypedFormGroup;

    subscriptions: Subscription[] = [];
    artikelListe: Artikel[];

    app = MyApp.current;

    artikelNr: UntypedFormControl;
    charge: UntypedFormControl;
    gtin: UntypedFormControl;
    nve: UntypedFormControl;
    mhd: UntypedFormControl;
    menge: UntypedFormControl;

    constructor(
        public formBuilder: UntypedFormBuilder,
        private auftragService: AuftragService,
        private modalController: ModalController,
        private popoverController: PopoverController,
        private stammdatenService: StammdatenService,
        private remoteService: RemoteService,
        private cdr: ChangeDetectorRef) {

        WareneinganScanPage.instance = this;

        this.form = this.formBuilder.group({
            artikelNr: ['', Validators.required],
            charge: ['', Validators.nullValidator],
            gtin: ['', Validators.nullValidator],
            nve: ['', Validators.nullValidator],
            mhd: ['', Validators.nullValidator],
            menge: ['', Validators.required],
        });

        this.artikelNr = this.form.get('artikelNr') as UntypedFormControl;
        this.charge = this.form.get('charge') as UntypedFormControl;
        this.gtin = this.form.get('gtin') as UntypedFormControl;
        this.nve = this.form.get('nve') as UntypedFormControl;
        this.mhd = this.form.get('mhd') as UntypedFormControl;
        this.menge = this.form.get('menge') as UntypedFormControl;

        this.subscriptions.push(this.form.valueChanges.pipe(debounceTime(1000)).subscribe((changes) => {
            for (let key of Object.keys(changes)) {
                this.entity[key] = changes[key];
            }
        }));
    }

    async ionViewWillEnter() {
        log?.debug('ionViewWillEnter');
    }

    ionViewDidEnter() {
        MyApp.current.backAction = () => this.onAbbrechen();

        this.checkVollstaendig();
    }

    async ionViewWillLeave() {
        log?.debug('ionViewWillLeave');
        MyApp.current.backAction = null;
        MyApp.loading(false);
    }

    async ngOnInit() {
        this.artikelListe = this.stammdatenService.artikelListe.getValue();

        if (this.isAendern) {
            // this.form.get('name').setValue(this.stoerzeit.Name);
            // this.form.get('dauer').setValue(this.stoerzeit.Dauer);
        }

        this.update(false);
    }

    update(schliessenWennVollstaendig: boolean) {
        this.artikelNr.setValue(this.entity.artikelNr);
        this.charge.setValue(this.entity.charge);
        this.gtin.setValue(this.entity.gtin);
        this.mhd.setValue(this.entity.mhd);
        this.nve.setValue(this.entity.nve);
        this.menge.setValue(this.entity.menge);

        this.cdr.detectChanges();

        if (schliessenWennVollstaendig) {
            this.checkVollstaendig();
        }
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        log?.debug('ngOnDestroy');

        this.subscriptions.forEach(p => p.unsubscribe());
        this.subscriptions = [];

        WareneinganScanPage.instance = null;
    }

    onArtikelChanged() {
        log?.debug('onArtikelChanged');

        // let name = this.form.get('name').value as string;

        // const definition = this.artikelListe.find(p => p.Name === name && this.typ == this.typ);

        // if (definition && definition.StandardDauer) {
        //     this.form.get('dauer').setValue(definition.StandardDauer);
        // }
    }

    onLoeschen() {
        this.popoverController.dismiss('loeschen');
    }

    checkVollstaendig() {
        log?.debug(`checkVollstaendig: ${this.artikelNr.value}, ${this.mhd.value}, ${this.menge.value}`);

        if (this.mhd.value 
            && this.artikelNr.value 
            && this.menge.value 
            && this.charge.value
            && this.form.valid) {
            log?.debug('checkVollstaendig: OK');
            this.onSpeichern();
        }
    }

    async onSpeichern() {
        log?.debug('onSpeichern');

        if (!this.form.valid) {
            UiHelper.showAlert('Formular nicht vollständig ausgefüllt');
            return;
        }

        this.popoverController.dismiss('OK');
    }

    onAbbrechen() {
        this.dismiss();
    }

    dismiss() {
        // using the injected ModalController this page
        // can "dismiss" itself and optionally pass back data
        this.popoverController.dismiss(false);
    }

    async selectDatum() {
        log?.debug('selectDatum');

        try {
            let date = new Date();

            let mhd = this.form.get('mhd').value as string;

            if (mhd && mhd.length >= 8 && mhd.length <= 10) {
                // Versuche das eingegebene Datum zu parsen
                date = moment(mhd).toDate();
            }

            // TODO CAPACITOR: Sollte aber besser auf app-input-datum umgebaut werden

            // date = await DatePicker.present({
            //     date: new Date(),
            //     mode: 'date',
            //     androidTheme: 'light'
            // });

            // if (date) {
            //     const m = moment(date);
            //     this.form.get('mhd').setValue(m.format('DD.MM.YYYY'));
            // }
        } catch (err) {
            // UiHelper.showError(err);
        }
    }

    async onArtikelAendern() {
        const modal = await this.modalController.create({
            component: AuftragArtikelAuswahlPage,
            componentProps: {
                'auftrag': null
            }
        });

        log?.debug('AuftragArtikelAuswahlPage wird angezeigt...');
        await modal.present();

        const modalResult = await modal.onDidDismiss();

        log?.debug('AuftragArtikelAuswahlPage wurde geschlossen', modalResult);

        if (!modalResult) {
            // Abbruch
            return;
        }

        const artikel = modalResult.data.artikel as Artikel;

        if (artikel) {
            this.form.get('artikelNr').setValue(artikel.artikelKey);
            this.cdr.detectChanges();
        }
    }
}
